var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path2, _path3, _path4, _g, _rect10, _rect11, _rect12, _rect13, _rect14, _path5, _path6, _path7, _path8, _g2, _circle, _rect15, _rect16, _rect17, _rect18, _rect19, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImgfilter2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 285,
  height: 140,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 142.29,
  height: 85.56,
  x: 49,
  y: 30.439,
  fill: "#fff",
  rx: 4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M62.5 39a3.51 3.51 0 0 0-3.5 3.5 3.51 3.51 0 0 0 3.5 3.5 3.51 3.51 0 0 0 3.5-3.5 3.51 3.51 0 0 0-3.5-3.5m-.7 5.25-1.75-1.75.494-.493L61.8 43.26l2.657-2.657.493.497zM62.5 49a3.51 3.51 0 0 0-3.5 3.5 3.51 3.51 0 0 0 3.5 3.5 3.51 3.51 0 0 0 3.5-3.5 3.51 3.51 0 0 0-3.5-3.5m-.7 5.25-1.75-1.75.494-.493L61.8 53.26l2.657-2.657.493.497zM62.5 58a3.51 3.51 0 0 0-3.5 3.5 3.51 3.51 0 0 0 3.5 3.5 3.51 3.51 0 0 0 3.5-3.5 3.51 3.51 0 0 0-3.5-3.5m-.7 5.25-1.75-1.75.494-.493L61.8 62.26l2.657-2.657.493.497z"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 41,
  height: 5,
  x: 70,
  y: 40,
  fill: "#D9D9D9",
  rx: 2
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 59,
  height: 5,
  x: 70,
  y: 50,
  fill: "#D9D9D9",
  rx: 2
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 44,
  height: 5,
  x: 70,
  y: 59,
  fill: "#D9D9D9",
  rx: 2
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 72.222,
  height: 26,
  x: 179,
  y: 69,
  fill: "#D2E3DF",
  rx: 2
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  width: 37.556,
  height: 3,
  x: 209.333,
  y: 74.777,
  fill: "#4DA791",
  rx: 1.5
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  width: 14.444,
  height: 3,
  x: 209.333,
  y: 80.555,
  fill: "#4DA791",
  rx: 1.5
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  width: 20.222,
  height: 3,
  x: 209.333,
  y: 84.889,
  fill: "#4DA791",
  rx: 1.5
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  width: 21,
  height: 20,
  x: 182,
  y: 72,
  fill: "#4DA791",
  rx: 1
})), /*#__PURE__*/React.createElement("mask", {
  id: "img_filter2_svg__a",
  width: 15,
  height: 11,
  x: 185,
  y: 76,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m186 86 .75-9h12l.75 9h-5.684l-1.066-4.125L191.684 86z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M193.875 79.625 192.75 77l-1.5 2.813"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M190.5 77h4.5"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#img_filter2_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M183.75 72.5h18v18h-18z"
}))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  width: 65,
  height: 26,
  x: 152,
  y: 103,
  fill: "#D2E3DF",
  rx: 2
})), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
  width: 33.28,
  height: 2.56,
  x: 179.88,
  y: 109.119,
  fill: "#4DA791",
  rx: 1.28
})), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
  width: 12.8,
  height: 2.56,
  x: 179.88,
  y: 114.24,
  fill: "#4DA791",
  rx: 1.28
})), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
  width: 17.92,
  height: 2.56,
  x: 179.88,
  y: 118.08,
  fill: "#4DA791",
  rx: 1.28
})), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
  width: 21,
  height: 20,
  x: 155,
  y: 106,
  fill: "#4DA791",
  rx: 1
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M167.082 110a2.2 2.2 0 0 1-2.041 1.375 2.2 2.2 0 0 1-2.042-1.375L158 112.116l1.406 3.309 1.546-.654v6.749h8.233v-6.724l1.489.631 1.406-3.31z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#008060",
  d: "M72 76a2 2 0 0 1 2-2h92a2 2 0 0 1 2 2v17.976a2 2 0 0 1-2 2H74a2 2 0 0 1-2-2z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 4.503,
  d: "M107 85h49"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 4.503,
  d: "M83.566 84.684h24.506",
  opacity: 0.4
})), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#img_filter2_svg__b)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 108.072,
  cy: 84.684,
  r: 4.901,
  fill: "#66B3A0"
}))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 108.073,
  cy: 84.684,
  r: 3.676,
  fill: "#fff"
})), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
  width: 67,
  height: 24.12,
  x: 171,
  y: 38,
  fill: "#D2E3DF",
  rx: 2
})), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
  width: 21,
  height: 20,
  x: 173,
  y: 40,
  fill: "#4DA791",
  rx: 1
})), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
  width: 34.84,
  height: 3,
  x: 199.14,
  y: 43.359,
  fill: "#4DA791",
  rx: 1.5
})), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
  width: 13.4,
  height: 3,
  x: 199.14,
  y: 48.719,
  fill: "#4DA791",
  rx: 1.5
})), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
  width: 18.76,
  height: 3,
  x: 199.14,
  y: 52.74,
  fill: "#4DA791",
  rx: 1.5
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m184.077 42 1.077.5s-.848 1.376-.539 2c.169.337 1.077.5 1.077.5-.538 1-1.077 2.5-1.077 3 2.693 1.5 2.693 4.5 5.385 5.5 0 2-2.692 3.5-7 3.5s-7-1.5-7-3.5c2.692-1 2.692-4 5.385-5.5 0-.5-.539-2-1.077-3 0 0 .908-.163 1.077-.5.309-.624-.539-2-.539-2l1.077-.5c0 1 .539 1.5 1.077 1.5s1.077-.5 1.077-1.5"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABEC3",
  d: "M186 12.213A2.106 2.106 0 0 0 186 8z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABEC3",
  d: "M188.106 12.213a2.107 2.107 0 1 0 0-4.213zM36 111.5a1.5 1.5 0 1 0 2.998.002A1.5 1.5 0 0 0 36 111.5M257.317 109.708c.177 0 .322.158.322.352v1.548c0 .193-.145.351-.322.351s-.323-.158-.323-.351v-1.548c0-.194.145-.352.323-.352M257.317 107.001c.177 0 .322.158.322.352v1.548c0 .193-.145.351-.322.351s-.323-.158-.323-.351v-1.548c0-.194.145-.352.323-.352M255.322 109.129h1.275c.177 0 .322.158.322.352s-.145.351-.322.351h-1.275c-.177 0-.322-.158-.322-.351 0-.194.145-.352.322-.352M258.035 109.129h1.274c.177 0 .322.158.322.352s-.145.351-.322.351h-1.274c-.178 0-.323-.158-.323-.351 0-.194.145-.352.323-.352"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "img_filter2_svg__b",
  width: 15.206,
  height: 15.207,
  x: 101.37,
  y: 77.982,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.901,
  dy: 0.901
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.351
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0.501961 0 0 0 0 0.376471 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_9997_6385"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_9997_6385",
  result: "shape"
})))));
export { SvgImgfilter2 as ReactComponent };
export default __webpack_public_path__ + "static/media/img.filter2.1fb3698e.svg";